import { IconWrapper, type IconProps } from '../SlideTypeIcon';

export const MiroIcon = ({ size }: IconProps) => (
  <IconWrapper size={size}>
    <path
      d="M22.1231 5H9.97887C7.21545 5 4.97461 7.29914 4.97461 10.1345V22.5941C4.97461 25.43 7.21545 27.7286 9.97887 27.7286H22.1226C24.8866 27.7286 27.1269 25.4294 27.1269 22.5941V10.1345C27.1269 7.29855 24.8866 5 22.1231 5ZM19.4961 23.4565H17.4727L19.1587 12.6492L15.4495 23.4565H13.4262L15.2807 13.3253L11.4029 23.4565H9.37962L11.4029 14.0008L9.37962 9.2725H11.4029L15.2807 12.9873L13.4262 9.2725H15.4495L19.1587 12.3118L17.4727 9.2725H19.4961L23.2052 11.6363L19.4961 23.4565Z"
      fill="#FFDD33"
    />
    <path
      d="M17.4732 9.27246L19.1591 12.3118L15.4505 9.27246H13.4272L15.2818 12.9872L11.4039 9.27246H9.38062L11.4039 14.0007L9.38062 23.4566H11.4039L15.2818 13.3252L13.4272 23.4566H15.4505L19.1591 12.6497L17.4732 23.4566H19.4965L23.2057 11.6363L19.4965 9.27246H17.4732Z"
      fill="#1C1C1E"
    />
  </IconWrapper>
);
